import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isSameOrAfter);
dayjs.extend(isBetween);

const isDateBetween = (startDate, endDate) => {
  if (!endDate) return dayjs().isSameOrAfter(startDate);
  return dayjs().isBetween(startDate, endDate, null, '[]');
};

export default isDateBetween;
